<!-- PedidosTabla.vue — Tabla de seguimiento para Tere (Laser) -->
<!-- Ordenamiento por columna, selector de filas, botón proyectos -->
<template>
  <div>
    <!-- ══ TABLA ESCRITORIO ════════════════════════════════════ -->
    <div class="divisan-table-container shadow-lg d-none d-lg-block">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-verde"></div>
        <p class="mt-3 text-cafe fw-bold small">Cargando pedidos...</p>
      </div>
      <table v-else class="table table-divisan align-middle mb-0">
        <colgroup>
          <col style="width: 8%" />
          <!-- Pedido -->
          <col style="width: 20%" />
          <!-- Cliente -->
          <col style="width: 10%" />
          <!-- Fecha recibo -->
          <col style="width: 10%" />
          <!-- Fecha compromiso -->
          <col style="width: 9%" />
          <!-- Días restantes -->
          <col style="width: 8%" />
          <!-- Prioridad -->
          <col style="width: 10%" />
          <!-- Estatus almacén -->
          <col style="width: 10%" />
          <!-- Estatus cliente -->
          <col style="width: 8%" />
          <!-- Acciones -->
        </colgroup>
        <thead>
          <tr>
            <th class="ps-4 sortable" @click="$emit('ordenar', 'numero_pedido')">
              <span class="th-inner">
                <span class="th-text">Pedido</span>
                <i :class="iconoOrden('numero_pedido')"></i>
              </span>
            </th>
            <th class="sortable" @click="$emit('ordenar', 'cliente')">
              <span class="th-inner">
                <span class="th-text">Cliente</span>
                <i :class="iconoOrden('cliente')"></i>
              </span>
            </th>
            <th class="sortable" @click="$emit('ordenar', 'fecha_recibo')">
              <span class="th-inner">
                <span class="th-text">Fecha recibo</span>
                <i :class="iconoOrden('fecha_recibo')"></i>
              </span>
            </th>
            <th class="sortable" @click="$emit('ordenar', 'fecha_compromiso')">
              <span class="th-inner">
                <span class="th-text">Fecha compromiso</span>
                <i :class="iconoOrden('fecha_compromiso')"></i>
              </span>
            </th>
            <th class="text-center sortable" @click="$emit('ordenar', 'dias_restantes')">
              <span class="th-inner th-inner--center">
                <span class="th-text">Días restantes</span>
                <i :class="iconoOrden('dias_restantes')"></i>
              </span>
            </th>
            <th class="text-center sortable" @click="$emit('ordenar', 'prioridad')">
              <span class="th-inner th-inner--center">
                <span class="th-text">Prioridad</span>
                <i :class="iconoOrden('prioridad')"></i>
              </span>
            </th>
            <th class="text-center sortable" @click="$emit('ordenar', 'estatus_almacen')">
              <span class="th-inner th-inner--center">
                <span class="th-text">Estatus almacén</span>
                <i :class="iconoOrden('estatus_almacen')"></i>
              </span>
            </th>
            <th class="text-center sortable" @click="$emit('ordenar', 'estatus_cliente')">
              <span class="th-inner th-inner--center">
                <span class="th-text">Estatus cliente</span>
                <i :class="iconoOrden('estatus_cliente')"></i>
              </span>
            </th>
            <th class="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in pedidos" :key="p.numero_pedido">
            <td class="ps-4">
              <span class="badge-molde">{{ p.numero_pedido }}</span>
            </td>
            <td>
              <div class="cliente-cell">
                <span class="cliente-num">{{ p.cliente_numero }}</span>
                <span class="cliente-nombre">{{ p.cliente }}</span>
              </div>
            </td>
            <td class="fecha-texto">{{ formatFecha(p.fecha_recibo) }}</td>
            <td class="fecha-texto">
              <span v-if="p.fecha_compromiso" class="fw-bold text-verde-oscuro">
                {{ formatFecha(p.fecha_compromiso) }}
              </span>
              <span v-else class="text-muted fst-italic" style="font-size: 0.75rem"
                >Sin asignar</span
              >
            </td>
            <td class="text-center">
              <span :class="badgeDias(p.dias_restantes)">{{
                labelDias(p.dias_restantes)
              }}</span>
            </td>
            <td class="text-center">
              <span :class="badgePrioridad(p.prioridad)">{{ p.prioridad }}</span>
            </td>
            <td class="text-center">
              <span :class="badgeEstatusAlmacen(p.estatus_almacen)">{{
                labelEstatus(p.estatus_almacen)
              }}</span>
            </td>
            <td class="text-center">
              <span :class="badgeEstatusCliente(p.estatus_cliente)">{{
                labelEstatusCliente(p.estatus_cliente)
              }}</span>
            </td>
            <td class="text-center">
              <div class="d-flex justify-content-center gap-2">
                <!-- Ver detalle -->
                <button
                  class="btn-circular"
                  title="Ver detalle"
                  @click="$emit('ver-detalle', p)"
                >
                  <i class="bi bi-list-ul text-dark"></i>
                </button>
                <!-- Ver proyectos -->
                <button
                  class="btn-circular btn-circular-pdf"
                  :class="{ 'sin-proyectos': !p.proyectos?.length }"
                  :title="p.proyectos?.length ? 'Ver proyectos PDF' : 'Sin proyectos'"
                  :disabled="!p.proyectos?.length"
                  @click="$emit('ver-proyectos', p)"
                >
                  <i class="bi bi-file-earmark-pdf"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="!loading && pedidos.length === 0">
            <td colspan="9" class="text-center py-5 text-cafe opacity-50 fw-bold">
              No se encontraron pedidos
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Paginación escritorio -->
      <div class="paginacion-wrapper">
        <div class="pag-izq">
          <small class="pag-info">
            {{ rangoInicio }}–{{ rangoFin }} de {{ totalRegistros }} pedidos
          </small>
          <div class="por-pagina-wrap">
            <label class="por-pagina-label">Filas:</label>
            <select
              class="por-pagina-select"
              :value="porPagina"
              @change="$emit('cambiar-por-pagina', Number($event.target.value))"
            >
              <option v-for="n in opcionesPorPagina" :key="n" :value="n">{{ n }}</option>
            </select>
          </div>
        </div>
        <div class="pag-der">
          <button
            class="btn-pag"
            :disabled="paginaActual === 1"
            @click="$emit('cambiar-pagina', 1)"
            title="Primera"
          >
            <i class="bi bi-chevron-double-left"></i>
          </button>
          <button
            class="btn-pag"
            :disabled="paginaActual === 1"
            @click="$emit('cambiar-pagina', paginaActual - 1)"
          >
            <i class="bi bi-chevron-left"></i>
          </button>
          <template v-for="pg in paginasVisibles" :key="pg">
            <span v-if="pg === '...'" class="pag-ellipsis">…</span>
            <button
              v-else
              :class="['btn-pag-num', { activo: pg === paginaActual }]"
              @click="$emit('cambiar-pagina', pg)"
            >
              {{ pg }}
            </button>
          </template>
          <button
            class="btn-pag"
            :disabled="paginaActual === totalPaginas"
            @click="$emit('cambiar-pagina', paginaActual + 1)"
          >
            <i class="bi bi-chevron-right"></i>
          </button>
          <button
            class="btn-pag"
            :disabled="paginaActual === totalPaginas"
            @click="$emit('cambiar-pagina', totalPaginas)"
            title="Última"
          >
            <i class="bi bi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- ══ CARDS MÓVIL ═════════════════════════════════════════ -->
    <div class="d-lg-none">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-verde"></div>
      </div>
      <template v-else>
        <div
          v-for="p in pedidos"
          :key="'mob-' + p.numero_pedido"
          class="divisan-mobile-card mb-3 p-3 shadow-sm"
        >
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div>
              <span class="badge-molde me-2">{{ p.numero_pedido }}</span>
              <span class="cliente-num">{{ p.cliente_numero }}</span>
            </div>
            <div class="d-flex gap-1 flex-wrap justify-content-end">
              <span :class="badgePrioridad(p.prioridad)">{{ p.prioridad }}</span>
              <span :class="badgeDias(p.dias_restantes)">{{
                labelDias(p.dias_restantes)
              }}</span>
            </div>
          </div>
          <div class="cliente-nombre mb-1">{{ p.cliente }}</div>
          <div class="d-flex justify-content-between mb-1">
            <small class="text-cafe">Recibo: {{ formatFecha(p.fecha_recibo) }}</small>
            <small class="text-cafe">
              Compromiso:
              <span v-if="p.fecha_compromiso">{{ formatFecha(p.fecha_compromiso) }}</span>
              <span v-else class="fst-italic">Sin asignar</span>
            </small>
          </div>
          <div class="d-flex gap-2 mb-2">
            <span :class="badgeEstatusAlmacen(p.estatus_almacen)">{{
              labelEstatus(p.estatus_almacen)
            }}</span>
            <span :class="badgeEstatusCliente(p.estatus_cliente)">{{
              labelEstatusCliente(p.estatus_cliente)
            }}</span>
          </div>
          <div class="d-flex gap-2">
            <button class="btn btn-sm btn-ver" @click="$emit('ver-detalle', p)">
              <i class="bi bi-list-ul me-1"></i>Ver detalle
            </button>
            <button
              class="btn btn-sm btn-ver-pdf"
              :disabled="!p.proyectos?.length"
              @click="$emit('ver-proyectos', p)"
            >
              <i class="bi bi-file-earmark-pdf me-1"></i>
              Proyectos{{ p.proyectos?.length ? ` (${p.proyectos.length})` : "" }}
            </button>
          </div>
        </div>

        <div
          v-if="!loading && pedidos.length === 0"
          class="text-center py-5 text-cafe opacity-50 fw-bold"
        >
          No se encontraron pedidos
        </div>

        <!-- Paginación móvil -->
        <div
          v-if="totalPaginas > 1"
          class="pagination-mobile d-flex justify-content-between align-items-center px-1 py-2 mt-1"
        >
          <button
            class="btn-pag-mobile"
            :disabled="paginaActual === 1"
            @click="$emit('cambiar-pagina', paginaActual - 1)"
          >
            <i class="bi bi-chevron-left"></i> Anterior
          </button>
          <small class="text-claro fw-bold"
            >{{ paginaActual }} / {{ totalPaginas }}</small
          >
          <button
            class="btn-pag-mobile"
            :disabled="paginaActual === totalPaginas"
            @click="$emit('cambiar-pagina', paginaActual + 1)"
          >
            Siguiente <i class="bi bi-chevron-right"></i>
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { usePedidoBadges } from "../Pedidos/composables/usePedidoBadges.js";

const props = defineProps({
  pedidos: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  paginaActual: { type: Number, default: 1 },
  totalPaginas: { type: Number, default: 1 },
  totalRegistros: { type: Number, default: 0 },
  porPagina: { type: Number, default: 10 },
  opcionesPorPagina: { type: Array, default: () => [5, 10, 15, 20] },
  rangoInicio: { type: Number, default: 0 },
  rangoFin: { type: Number, default: 0 },
  ordenCampo: { type: String, default: "" },
  ordenAsc: { type: Boolean, default: true },
});

defineEmits([
  "ver-detalle",
  "ver-proyectos",
  "cambiar-pagina",
  "cambiar-por-pagina",
  "ordenar",
]);

const {
  formatFecha,
  labelDias,
  badgeDias,
  badgePrioridad,
  badgeEstatusAlmacen,
  badgeEstatusCliente,
  labelEstatus,
  labelEstatusCliente,
} = usePedidoBadges();

function iconoOrden(campo) {
  if (props.ordenCampo !== campo) return "bi bi-arrow-down-up ms-1 icono-orden";
  return props.ordenAsc
    ? "bi bi-arrow-up ms-1 icono-orden activo"
    : "bi bi-arrow-down ms-1 icono-orden activo";
}

const paginasVisibles = computed(() => {
  const total = props.totalPaginas;
  const actual = props.paginaActual;
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const set = new Set([1, total, actual]);
  if (actual > 1) set.add(actual - 1);
  if (actual < total) set.add(actual + 1);
  const ordenadas = [...set].sort((a, b) => a - b);
  const resultado = [];
  for (let i = 0; i < ordenadas.length; i++) {
    if (i > 0 && ordenadas[i] - ordenadas[i - 1] > 1) resultado.push("...");
    resultado.push(ordenadas[i]);
  }
  return resultado;
});
</script>

<style scoped>
.text-claro {
  color: var(--d-cream);
}
.text-cafe {
  color: var(--d-brown);
}
.text-verde {
  color: var(--d-green);
}
.text-verde-oscuro {
  color: var(--d-green-dark);
}
.fecha-texto {
  color: var(--d-green);
  font-weight: 700;
  font-size: 0.76rem;
}

/* ── Cliente cell ───────────────────────────────────────── */
.cliente-cell {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.cliente-num {
  font-family: var(--d-font-mono);
  font-size: 0.68rem;
  font-weight: 700;
  color: var(--d-green);
}
.cliente-nombre {
  font-size: 0.76rem;
  color: var(--d-brown);
  font-weight: 800;
  word-break: break-word;
  overflow-wrap: break-word;
}

/* ── Tabla ──────────────────────────────────────────────── */
.divisan-table-container {
  background-color: var(--d-cream);
  border-radius: 15px;
  overflow: hidden;
}

.table-divisan {
  table-layout: fixed;
  width: 100%;
}

.table-divisan thead th {
  background: var(--d-cream);
  color: var(--d-brown);
  border-bottom: 3px solid var(--d-brown);
  padding: 8px 10px;
  font-weight: 800;
  border-top: none;
  font-size: 0.72rem;
  vertical-align: middle;
  white-space: normal;
  overflow: hidden;
}

/* Celdas de datos: texto largo no desborda */
/* Primera columna: padding izquierdo más ajustado */
.table-divisan thead th.ps-4 {
  padding-left: 12px;
}
.table-divisan tbody td.ps-4 {
  padding-left: 12px;
}

.table-divisan td {
  border-bottom: 1px solid rgba(96, 108, 56, 0.1);
  padding: 7px 9px;
  font-size: 0.78rem;
  overflow: hidden;
}
.table-divisan tbody tr:hover td {
  background-color: rgba(96, 108, 56, 0.04);
}

/* ── Encabezado: texto + ícono en flex ──────────────────── */
.th-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: 100%;
}

/* Para columnas centradas: el texto también se centra */
.th-inner--center {
  justify-content: center;
  gap: 4px;
}

.th-text {
  flex: 1;
  line-height: 1.25;
  word-break: break-word;
}

/* ── Ordenamiento ────────────────────────────────────────── */
.sortable {
  cursor: pointer;
  user-select: none;
  white-space: normal;
}
.sortable:hover {
  color: var(--d-green);
}
.icono-orden {
  font-size: 0.65rem;
  opacity: 0.35;
  flex-shrink: 0;
  vertical-align: middle;
}
.icono-orden.activo {
  opacity: 1;
  color: var(--d-green);
}

/* ── Badges ──────────────────────────────────────────────── */
.badge-molde {
  background: none;
  color: var(--d-brown);
  padding: 0;
  border-radius: 0;
  font-family: var(--d-font-mono);
  font-size: 0.82rem;
  font-weight: 600;
  opacity: 0.6;
}
.badge-prioridad {
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: capitalize;
}
.badge-prioridad.alta {
  background: #fdecea;
  color: #c0392b;
}
.badge-prioridad.media {
  background: #fff8e1;
  color: #b7770d;
}
.badge-prioridad.baja {
  background: #e8f5e9;
  color: #2e7d32;
}

.badge-estatus {
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 0.68rem;
  font-weight: 800;
  white-space: nowrap;
}
.badge-estatus.en_proceso {
  background: #e3f2fd;
  color: #1565c0;
}
.badge-estatus.listo {
  background: #e8f5e9;
  color: #2e7d32;
}
.badge-estatus.entregado {
  background: #e8f5e9;
  color: #1b5e20;
}
.badge-estatus.cancelado {
  background: #fce4ec;
  color: #880e4f;
}
.badge-estatus.atrasado {
  background: #fdecea;
  color: #c0392b;
}
.badge-estatus.en_tiempo {
  background: #e8f5e9;
  color: #2e7d32;
}
.badge-estatus.entrega_en_tiempo {
  background: #e0f2f1;
  color: #004d40;
}
.badge-estatus.entrega_con_atraso {
  background: #fff3e0;
  color: #e65100;
}
.badge-estatus.sin-fecha {
  background: rgba(64, 34, 8, 0.07);
  color: rgba(64, 34, 8, 0.45);
  font-style: italic;
}

/* ── Botones circulares ──────────────────────────────────── */
.btn-circular {
  background: white;
  border: 1px solid var(--d-green);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
  font-size: 0.85rem;
}
.btn-circular:hover {
  background: var(--d-green);
  color: var(--d-cream);
}

.btn-circular-pdf {
  border-color: #c0392b;
  color: #c0392b;
}
.btn-circular-pdf:hover:not(:disabled) {
  background: #c0392b;
  color: white;
  border-color: #c0392b;
}
.btn-circular-pdf.sin-proyectos {
  border-color: rgba(64, 34, 8, 0.2);
  color: rgba(64, 34, 8, 0.25);
}
.btn-circular:disabled {
  opacity: 0.3;
  cursor: default;
}

/* ── Botones móvil ──────────────────────────────────────── */
.btn-ver {
  background-color: var(--d-brown);
  color: var(--d-cream);
  border: none;
  font-weight: 600;
}
.btn-ver:hover {
  background-color: var(--d-green-dark);
  color: var(--d-cream);
}
.btn-ver-pdf {
  background-color: #fdecea;
  color: #c0392b;
  border: 1px solid rgba(192, 57, 43, 0.35);
  font-weight: 600;
}
.btn-ver-pdf:hover:not(:disabled) {
  background-color: #c0392b;
  color: white;
}
.btn-ver-pdf:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* ── Cards móvil ─────────────────────────────────────────── */
.divisan-mobile-card {
  background-color: var(--d-cream);
  border-radius: 15px;
  border-left: 6px solid var(--d-green);
}

/* ── Paginación desktop ──────────────────────────────────── */
.paginacion-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  flex-wrap: wrap;
  gap: 8px;
  border-top: 1px solid rgba(64, 34, 8, 0.1);
  background: rgba(96, 108, 56, 0.05);
}
.pag-izq {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.pag-der {
  display: flex;
  align-items: center;
  gap: 4px;
}
.pag-info {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}
.por-pagina-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-select {
  appearance: none;
  -webkit-appearance: none;
  background: white
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23606c38' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E")
    no-repeat right 8px center;
  border: 1.5px solid var(--d-green);
  border-radius: 8px;
  padding: 3px 26px 3px 10px;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--d-brown);
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s;
  min-width: 58px;
}
.por-pagina-select:focus,
.por-pagina-select:hover {
  border-color: var(--d-brown);
}

.btn-pag {
  background: white;
  border: 1px solid var(--d-green);
  color: var(--d-brown);
  border-radius: 8px;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}
.btn-pag:hover:not(:disabled) {
  background-color: var(--d-green);
  color: var(--d-cream);
}
.btn-pag:disabled {
  opacity: 0.35;
  cursor: default;
}

.btn-pag-num {
  background: white;
  border: 1.5px solid rgba(96, 108, 56, 0.25);
  color: var(--d-brown);
  border-radius: 8px;
  min-width: 34px;
  height: 34px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s;
  font-size: 0.82rem;
  font-weight: 700;
}
.btn-pag-num:hover {
  background: rgba(96, 108, 56, 0.1);
  border-color: var(--d-green);
}
.btn-pag-num.activo {
  background: var(--d-brown);
  color: var(--d-cream);
  border-color: var(--d-brown);
  pointer-events: none;
}
.pag-ellipsis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 34px;
  font-size: 0.85rem;
  color: var(--d-brown);
  opacity: 0.4;
  font-weight: 700;
}

/* ── Paginación móvil ────────────────────────────────────── */
.pagination-mobile {
  border-top: 1px solid rgba(64, 34, 8, 0.15);
}
.btn-pag-mobile {
  background: var(--d-cream);
  border: 1px solid var(--d-green);
  color: var(--d-brown);
  border-radius: 10px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 110px;
  justify-content: center;
}
.btn-pag-mobile:hover:not(:disabled) {
  background-color: var(--d-green);
  color: var(--d-cream);
}
.btn-pag-mobile:disabled {
  opacity: 0.35;
  cursor: default;
}
</style>
